import type { ReactNode } from "react";
import { useContext, createContext } from "react";
export interface ActiveWorkflowContext {
    isLoading: boolean;
    loadingError: Error | null;
    cancelWorkflow: () => void;
    hideCancelButton: boolean;
}
const activeWorkflowContext = createContext<ActiveWorkflowContext | null>(null);
export function ActiveWorkflowContextProvider({ value, children }: {
    value: ActiveWorkflowContext;
    children: ReactNode;
}) {
    return <activeWorkflowContext.Provider value={value}>{children}</activeWorkflowContext.Provider>;
}
export function useActiveWorkflowContext() {
    const activeWorkflowLoadingState = useContext(activeWorkflowContext);
    if (activeWorkflowLoadingState === null) {
        throw new Error("Can't find active workflow context provider");
    }
    return activeWorkflowLoadingState;
}
